import Toastify from 'toastify-js'

const customLogin = () => {
  // get the teacher form
  let form = document.getElementById("login_form");

  // check if the form exists in the DOM
  if (form) {
    // create submit event listener
    form.addEventListener("submit", (ev) => {
      // Prevent form submission
      ev.preventDefault();

      // Get form data
      const data = new FormData(form);
      data.append("action", "custom_login");

      // Make the AJAX request
      fetch("/wp-admin/admin-ajax.php", {
        method: "POST",
        body: data,
      })
        .then((response) => response.text())
        .then((response) => {
          // check if the response is JSON
          try {
            const jsonObject = JSON.parse(response);
            //console.error(jsonObject);
          //  alert(jsonObject.data.message);

            Toastify({
              text: jsonObject.data.message,
              duration: 2000,
              gravity: "bottom", // `top` or `bottom`
              position: "right", // `left`, `center` or `right`,
              className: "rounded-md shadow", 
              style: {
                background: "#000000",
              },
              callback: () => {
                if (jsonObject.data.success) {
                  location.href = "/wp-admin/";
                }
              } 
            }).showToast();

          } catch (error) {
            // not JSON, weird HTML redirect bullshit
            const htmlString = response;
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlString, "text/html");
            const linkTag = doc.querySelector('link[rel="canonical"]');
            const href = linkTag.getAttribute("href");
            location.href = href;
          }
        })
        .catch((error) => {
          // Handle any errors
          console.error(error);
        });
    });
  }
};

export { customLogin };
